import type { SocialProviderType } from "./authClient";

export const CREDENTIAL_PROVIDER_ID = "credential";

/** How a user signs in, grouped the way they'd recognise it. */
export type AccountProviderKind = typeof CREDENTIAL_PROVIDER_ID | SocialProviderType | "sso";

export const ACCOUNT_PROVIDER_LABELS: Record<AccountProviderKind, string> = {
  credential: "Email & password",
  google: "Google",
  microsoft: "Microsoft",
  sso: "Company SSO",
};

/** Enterprise SSO providers have company-specific ids (`<companyGuid>-…`), so anything unknown is SSO. */
export function accountProviderKind(providerId: string): AccountProviderKind {
  if (
    providerId === CREDENTIAL_PROVIDER_ID ||
    providerId === "google" ||
    providerId === "microsoft"
  ) {
    return providerId;
  }
  return "sso";
}
